import auth from "@react-native-firebase/auth";
import { setLocalStorageItem } from "core/helpers";
import navhelper from "core/navhelper";
import { useContext, useEffect, useState } from "react";
import { BiSolidDashboard } from "react-icons/bi";
import { Dimensions } from "react-native";
import { useLocation } from 'react-router-dom';
import back_arrow_png from "res/img/back_arrow.png";
import projectIcon from "res/img/projectIcon.png";
import chatIcon from "res/img/chat.png"
import closeIcon from "res/img/cross.png";
 import home_selected_svg from "res/img/homeIcon.png"
import profileIcon from "res/img/profileIcon.png"
import signOut from "res/img/signOut.png";
import menu_subscription from "res/img/menuSubscription.png";
import settingIcon from "res/img/settings.png"
import timeOff from "res/img/timeOffIcon.png";
import styles from "./styles/MenuStyles";
import Dialog from "src/components/Dialog";
import { isAdminUser } from "src/utils/UserUtils";
import "./Menu.css";
import { NotificationContext } from "src/context/NotificationContext";
interface MenuProps {
  backEnabled?: boolean
  setIsUserMenuIconPosition?: (position: boolean) => void;
  isUserMenuIconPosition?: boolean;
  drawerOpen?: boolean
}
function Menu({ backEnabled, setIsUserMenuIconPosition, isUserMenuIconPosition, drawerOpen }: MenuProps) {
  const windowHeight = Dimensions.get('window').height;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation().pathname
  const [showToast, setShowToast] = useState(false);
 
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (setIsUserMenuIconPosition) {
      setIsUserMenuIconPosition(!isUserMenuIconPosition);
    }
  };
  const [current, setCurrent] = useState("");
  const [userType, setUserType] = useState("Normal");
const {messageCount,setMessageCount}=useContext(NotificationContext);

  const logOut = () => {
    auth().signOut().then(() => {
      setLocalStorageItem("loggedinUser", null);
      navhelper.push('LoginScreen');
    }).catch((error) => {
      console.error("Sign Out Error", error);
    });
  }

  useEffect(() => {
if(current==="UserChatScreen"){
setMessageCount(0)

}
   
  })
  useEffect(() => {
    let screen = 'HomeScreen'
    if (location.startsWith('/') && location.length > 1) {
      screen = location.substr(1);
      if (screen.includes("AdminTimeOff") || screen.includes("UserTimeOff")) {
        screen = "timeOff"
      }
    }
    setCurrent(screen);
    auth()
      .getCurrentUser()
      .then((user) => {
        if (isAdminUser(user)) {
          setUserType("Admin");
        }
        else {
          setUserType("Normal");
        }
      })
      .catch((error) => {
        console.error("Error getting current user:", error);
      });
  }, [location]);

  return (
    <div className="app" style={styles.app}>
      <Dialog confirm={true} message={"Are you sure"}
        handleDialogConfirm={logOut}
        isDialogVisible={showToast}
        onDialogClose={() => setShowToast(false)}
        title="Logout"
        confirmText="Logout"
      />

      <div className="sidebar">
        <div
          style={styles.mainFont}
        >
          Staff Docker
        </div>
        {!backEnabled && <div>
          <div
            className="menu-tab"
            style={{
              marginTop: 34,
              backgroundColor: current.includes("HomeScreen")
                ? "#2F485833"
                : undefined,
            }}
            onClick={() => {
              if (current !== 'HomeScreen') {
                setCurrent("HomeScreen");
                if (userType === "Normal") {
                  navhelper.push("HomeScreen");
                } else {
                  navhelper.push("AdminHomeScreen");
                }
              }
            }}
          >
            <div style={styles.leftSpacing}>
              <img src={home_selected_svg} alt="home icon" style={styles.timeOffIcon} />
            </div>
            <div
              style={styles.homeText}
              className="menu-text"
            >
              Home
            </div>
          </div>
          <div>
            <div
              className="menu-tab"
              style={{
                backgroundColor: current.includes("ProfileScreen")
                  ? "#2F485833"
                  : undefined,
              }}
              onClick={() => {

                setCurrent("ProfileScreen");
                if (userType === 'Normal') {
                  navhelper.push('UserProfileScreen')
                } else {
                  navhelper.push('AdminProfileScreen')
                }
              }}
            >
              <div style={{ marginLeft: 28 }}>
                <img
                  src={profileIcon}
                  alt="profile icon"
                  style={styles.profileIcon}
                />
              </div>
              <div
                style={styles.componentText}
                className="menu-text"
              >
                Profile
              </div>
            </div>
          </div>
          <div>
            <div
              className="menu-tab"
              style={{
                backgroundColor: current.includes("timeOff")
                  ? "#2F485833"
                  : undefined,
              }}
              onClick={() => {
                setCurrent("timeOff");
                if (userType === 'Normal') {
                  navhelper.push('UserTimeOffRequest')
                } else {
                  navhelper.push('AdminTimeOffScreen')
                }
              }}
            >
              <div style={styles.leftSpacingSecondary}>
                <img
                  src={timeOff}
                  alt="profile icon"
                  style={styles.leaveRequestIcon}
                />
              </div>
              <div
                style={styles.leave}
                className="menu-text"
              >Leave Request
              </div>
            </div>
          </div>


          <div>
            <div
              className="menu-tab"
              style={{
                backgroundColor: current.includes("UserDetailReportScreen")
                  ? "#2F485833"
                  : undefined,
              }}
              onClick={() => {
                setCurrent("UserDetailReportScreen");
                navhelper.push('UserDetailReportScreen')
              }}
            >
              <div style={styles.leftSpacingSecondary}>
                <img
                  src={menu_subscription}
                  alt="menu_subscription icon"
                  style={styles.menuSubcription}
                />
              </div>
              <div
                style={styles.leave}
                className="menu-text"
              >
                Report
              </div>
            </div>
          </div>
          <div>
            <div
              className="menu-tab"
              style={{
                backgroundColor: current.includes("UserChatScreen")
                  ? "#2F485833"
                  : undefined,
              }}
              onClick={() => {
                setCurrent("UserChatScreen");
                navhelper.push('UserChatScreen')
              }}
            >
              <div style={styles.leftSpacingSecondary}>
                <img
                  src={chatIcon}
                  alt="chat icon"
                  style={styles.menuSubcription}
                />
              </div>
              <div
                style={styles.leave}
                className="menu-text"
              >
               
                Chat{messageCount>0&&<div style={styles.chatCount}>{messageCount}</div>}
              </div>
            </div>
          </div>
          <div
            className="menu-tab"
            style={{
              backgroundColor: current.includes("AdminReviewsScreen")
                ? "#2F485833"
                : undefined,
            }}
            onClick={() => {
              setCurrent("AdminReviewsScreen");
              navhelper.push('AdminReviewsScreen')
            }}
          >
            <div style={styles.leftSpacingSecondary}>
              <img
                src={profileIcon}
                alt="recruiter"
                style={styles.profileIcon}
              />
            </div>
            <div
              style={{...styles.leave,paddingLeft:3}}
              className="menu-text"
            >
               Reviews
            </div>
          </div>
          {userType == 'Normal' && (
            <div>
              <div
                className="menu-tab"
                style={{
                  backgroundColor: current.includes("TeamAvailability")
                    ? "#2F485833"
                    : undefined,
                }}
                onClick={() => {
                  setCurrent("TeamAvailability");
                  navhelper.push('TeamAvailability')
                }}
              >
                <div style={styles.leftSpacingSecondary}>
                  <BiSolidDashboard fontSize={20} />
                </div>
                <div
                  style={styles.profileText}
                  className="menu-text"
                >
                  Team Availability
                </div>
              </div>
            </div>
          )}
          {userType === 'Admin' &&
            <>
              <div>
                <div
                  className="menu-tab"
                  style={{
                    backgroundColor: current.includes("ReviewAssignmentScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("ReviewAssignmentScreen");
                    navhelper.push('ReviewAssignmentScreen')
                  }}
                >
                  <div style={styles.leftSpacingSecondary}>
                    <img
                      src={menu_subscription}
                      alt="menu_subscription icon"
                      style={styles.menuSubcription}
                    />
                  </div>
                  <div
                    style={styles.leave}
                    className="menu-text"
                  >
                    Assign Reviews
                  </div>
                </div>
              </div>
              <div>
                <div
                  className="menu-tab"
                  style={{
                    backgroundColor: current.includes("RecruitmentScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("RecruitmentScreen");
                    navhelper.push('RecruitmentScreen')
                  }}
                >
                  <div style={styles.leftSpacingSecondary}>
                    <img
                      src={profileIcon}
                      alt="recruiter"
                      style={styles.profileIcon}
                    />
                  </div>
                  <div
                    style={{...styles.leave,paddingLeft:3}}
                    className="menu-text"
                  >
                    Recruiter
                  </div>
                </div>
              </div>
              <div
                className="menu-tab"
                style={{
                  backgroundColor: current.includes("ProjectScreen")
                    ? "#2F485833"
                    : undefined,
                }}
                onClick={() => {
                  setCurrent("ProjectScreen");
                  navhelper.push('ProjectScreen');
                }}
              >
                <div style={styles.leftSpacingSecondary}>
                  <img
                    src={projectIcon}
                    alt="project"
                    style={styles.profileIcon}
                  />
                </div>
                <div
             style={{...styles.leave,paddingLeft:3}}
                  className="menu-text"
                >
                  Project
                </div>
              </div>
              <div
                className="menu-tab"
                style={{
                  backgroundColor: current.includes("AdminQuestionnaireScreen")
                    ? "#2F485833"
                    : undefined,
                }}
                onClick={() => {
                  setCurrent("AdminQuestionnaireScreen");
                  navhelper.push('AdminQuestionnaireScreen')
                }}
              >
                <div style={styles.leftSpacingSecondary}>
                  <img
                    src={profileIcon}
                    alt="recruiter"
                    style={styles.profileIcon}
                  />
                </div>
                <div
                   style={{...styles.leave,paddingLeft:2}}
                  className="menu-text"
                >Questionnaire
                </div>
              </div>
              <div style={styles.setting}
                onClick={() => {
                  setCurrent("UserSettingScreen");
                  navhelper.push('UserSettingScreen')
                }} >
                <div
                  className="menu-tab"
                >
                  <div style={styles.leftAlpha}>
                    <img
                      src={settingIcon}
                      alt="setting icon"
                      style={styles.settingIcon}
                    />
                  </div>
                  <div
                    style={{...styles.settingText,paddingLeft:3}}
                    className="menu-text"
                  >
                    Setting
                  </div>
                </div>
              </div>
            </>
          }
          <div style={styles.signOut}
            onClick={() => setShowToast(true)}
          >
            <div
              className="menu-tab"
            >
              <div style={styles.leftSpacing}>
                <img
                  src={signOut}
                  alt="signout icon"
                  style={styles.signOutIcon}
                />
              </div>
              <div
                style={{...styles.settingText,paddingLeft:6}}
                className="menu-text"
              >
                Sign out
              </div>
            </div>
          </div >

        </div >
        }

        {
          backEnabled &&
          <div style={styles.back}>
            <div
              className="menu-tab"
              style={styles.cursor}
              onClick={() => navhelper.goBack()}
            >
              <div style={styles.leftSpacing}>
                <img
                  src={back_arrow_png}
                  alt="back icon"
                  style={styles.backIcon}
                />
              </div>
              <div
                style={styles.backText}
                className="menu-text"
              >
                Back
              </div>
            </div>
            {userType === 'Admin' && <div
              className="menu-tab"

              style={{
                backgroundColor: current.includes("UserProfileScreen")
                  ? "#2F485833"
                  : undefined,
              }}
              onClick={() => navhelper.push('UserProfileScreen', { editUser: true })}
            >
              <div style={styles.leftSpacing}>
                <img
                  src={profileIcon}
                  alt="profile icon"
                  style={styles.profileIcon}
                />
              </div>
              <div
                style={styles.profileText}
                className="menu-text"
              >
                Manage Profile
              </div>
            </div>}
          </div>
        }
      </div >
      <div className="mobile" style={{ height: isMobileMenuOpen ? windowHeight : undefined }}>
        <div className="content" style={styles.mobile}>
          {!isMobileMenuOpen && (
            <>
              <div
                className="mobile-toggle"
                onClick={toggleMobileMenu}
                style={{ position: "absolute", right: 20, top: 20, display: drawerOpen ? "none" : "block" }}
              >
                <div className="bar"> </div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
              {backEnabled === true && <div
                className="mobile-toggle"
                onClick={toggleMobileMenu}
                style={styles.cancel}
              >
                <div><img src={back_arrow_png} alt="" style={styles.cancelIcon} onClick={() => navhelper.goBack()} /></div>
              </div>}
            </>
          )}

          {isMobileMenuOpen && (
            <div className="header" style={styles.header}>
              <div
                className="titlebig"
                style={styles.titleBig}
              >
                Staff Docker
              </div>
              <div
                onClick={() => {
                  toggleMobileMenu();
                }}
                className="cross"
              >
                <img
                  src={closeIcon}
                  alt="cancel icon"
                  style={styles.cancelIconMobile}
                />
              </div>
            </div>
          )}
        </div>
        <div>
          {isMobileMenuOpen && !backEnabled && (
            <div
              className="mobile-men"
              style={styles.mobileMenu}
            >
              <div style={styles.mobileView} />
              <div>
                <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("HomeScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    if (current !== 'HomeScreen') {
                      setCurrent("HomeScreen");
                      if (userType === "Normal") {
                        navhelper.push("HomeScreen");
                      }
                      else {
                        navhelper.push("AdminHomeScreen");
                      }
                    }
                  }}
                >
                  <div style={styles.leftAlpha}>
                    <img
                      alt="home icon"
                      src={home_selected_svg}
                      style={styles.timeOffIcon}
                    />
                  </div>
                  <div
                    style={styles.mobileHome}
                  >
                    Home
                  </div>
                </div>
                <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("ProfileScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("ProfileScreen");
                    if (userType === 'Normal') {
                      navhelper.push('UserProfileScreen')
                    } else {
                      navhelper.push('AdminProfileScreen')
                    }
                  }
                  }
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="profile icon"
                      src={profileIcon}
                      style={styles.profileIcon}
                    />
                  </div>
                  <div
                    style={styles.profileText}
                  >
                    Profile
                  </div>
                </div>
                <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("timeOff")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("timeOff");
                    if (userType === 'Normal') {
                      navhelper.push('UserTimeOffRequest')
                    }
                    else {
                      navhelper.push('AdminTimeOffScreen')
                    }
                  }}
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="profile icon"
                      src={timeOff}
                      style={styles.timeOffIcon}
                    />
                  </div>
                  <div
                    style={styles.profileText}
                  >
                    Leave Request
                  </div>
                </div>

                {userType === 'Admin' && <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("ReviewAssignmentScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("ReviewAssignmentScreen");
                    if (userType === 'Admin') {
                      navhelper.push('ReviewAssignmentScreen')
                    }
                    else {
                      navhelper.push('ReviewAssignmentScreen')
                    }
                  }}
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="profile icon"
                      src={menu_subscription}
                      style={styles.menuSubcription}
                    />
                  </div>
                  <div
                    style={styles.profileText}
                  >
                    Assign Reviews
                  </div>
                </div>}
                {userType !== 'Admin' &&

                  <div
                    className="mini-menu"
                    style={{
                      ...styles.miniMenu,
                      backgroundColor: current.includes("UserDetailReportScreen")
                        ? "#2F485833"
                        : undefined,
                    }}
                    onClick={() => {
                      setCurrent("UserDetailReportScreen");
                      navhelper.push('UserDetailReportScreen')
                    }
                    }
                  >
                    <div style={styles.leftSpacing}>
                      <img
                        alt="profile icon"
                        src={menu_subscription}
                        style={styles.menuSubcription}
                      />
                    </div>
                    <div
                      style={styles.profileText}
                    >
                      Report
                    </div>
                  </div>}
                <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("UserChatScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("UserChatScreen");
                    navhelper.push('UserChatScreen')
                  }
                  }
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="chat icon"
                      src={chatIcon}
                      style={styles.menuSubcription}
                    />
                  </div>
                  <div
                    style={styles.profileText}
                  >
                    Chat
                  </div>
                </div >
                <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("AdminReviewsScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("AdminReviewsScreen");
                    navhelper.push('AdminReviewsScreen')
                  }
                  }
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="recruiter icon"
                      src={profileIcon}
                      style={styles.profileIcon}
                    />
                  </div>
                  <div
                    style={styles.leave}
                  >
                    Reviews
                  </div>
                </div>
                {userType === 'Admin' && <>  <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("RecruitmentScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("RecruitmentScreen");
                    navhelper.push('RecruitmentScreen')
                  }
                  }
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="recruiter icon"
                      src={profileIcon}
                      style={styles.profileIcon}
                    />
                  </div>
                  <div
                     style={styles.leave}
                  >
                    Recruiter
                  </div>
                </div>
                  <div
                    className="mini-menu"
                    style={{
                      ...styles.miniMenu,
                      backgroundColor: current.includes("AdminQuestionnaireScreen")
                        ? "#2F485833"
                        : undefined,
                    }}
                    onClick={() => {
                      setCurrent("AdminQuestionnaireScreen");
                      navhelper.push('AdminQuestionnaireScreen')
                    }
                    }
                  >
                    <div style={styles.leftSpacing}>
                      <img
                        alt="recruiter icon"
                        src={profileIcon}
                        style={styles.profileIcon}
                      />
                    </div>
                    <div
                      style={styles.profileText}
                    >
                      Questionnaire
                    </div>
                  </div>
                </>}
                <div
                  className="mini-menu"
                  style={styles.mobileSignOut}
                  onClick={() => setShowToast(true)}
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="Close icon"
                      src={signOut}
                      style={styles.signOutIcon}
                    />
                  </div>
                  <div
                    style={styles.signOutTextMobile}
                  >
                    Sign out
                  </div >
                </div >
                {userType === 'Admin' && <div
                  className="mini-menu"
                  style={{
                    ...styles.miniMenu,
                    backgroundColor: current.includes("UserDetailReportScreen")
                      ? "#2F485833"
                      : undefined,
                  }}
                  onClick={() => {
                    setCurrent("UserDetailReportScreen");
                    navhelper.push('UserDetailReportScreen')
                  }
                  }
                >
                  <div style={styles.leftSpacing}>
                    <img
                      alt="profile icon"
                      src={menu_subscription}
                      style={styles.menuSubcription}
                    />
                  </div>
                  <div
                    style={styles.profileText}
                  >
                    Report
                  </div>
                </div>}
                {
                  userType !== 'Admin' && (
                    <div
                      className="mini-menu"
                      style={{
                        ...styles.miniMenu,
                        backgroundColor: current.includes("TeamAvailability")
                          ? "#2F485833"
                          : undefined,
                      }}
                      onClick={() => {
                        setCurrent("TeamAvailability");
                        navhelper.push('TeamAvailability')
                      }
                      }
                    >
                      <div style={styles.leftSpacing}>
                        <BiSolidDashboard fontSize={18} />
                      </div>
                      <div
                        style={styles.profileText}
                      >
                        Team Availability
                      </div>
                    </div>
                  )
                }
                {
                  userType === 'Admin' &&
                  <>

                    <div
                      className="mini-menu"
                      style={{
                        ...styles.miniMenu,
                        backgroundColor: current.includes("ProjectScreen")
                          ? "#2F485833"
                          : undefined,
                      }}
                      onClick={() => {
                        setCurrent("ProjectScreen");
                        navhelper.push('ProjectScreen')
                      }
                      }
                    >
                      <div style={styles.leftSpacing}>
                        <img
                          alt="project icon"
                          src={projectIcon}
                          style={styles.profileIcon}
                        />
                      </div>
                      <div
                        style={styles.profileText}
                      >
                        Project
                      </div>
                    </div>

                  </>
                }
                <div
                  className="mini-menu"
                  style={styles.mobileSetting}
                  onClick={() => {
                    setCurrent("UserSettingScreen");
                    navhelper.push('UserSettingScreen')
                  }}
                >
                  <div style={styles.leftAlpha}>
                    <img
                      alt="Close icon"
                      src={settingIcon}
                      style={styles.settingIcon}
                    />
                  </div>
                  <div
                    style={styles.settingText}
                  >
                    Setting
                  </div>
                </div>
              </div >
            </div >
          )
          }
          {
            isMobileMenuOpen && backEnabled === true && (
              <div
                className="mobile-men"
                style={styles.mobileMenu}
              >
                <div style={styles.menuContainer} />
                <div>
                  <div
                    className="mini-menu"
                    style={{
                      ...styles.miniMenu,
                      backgroundColor: current.includes("UserProfileScreen")
                        ? "#2F485833"
                        : undefined,
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      if (userType === "Admin") {
                        navhelper.push('UserProfileScreen', { editUser: true })
                      }
                    }}
                  >
                    <div style={styles.leftSpacing}>
                      <img
                        alt="Manage Profile Icon"
                        src={profileIcon}
                        style={styles.signOutIcon}
                      />
                    </div>
                    <div
                      style={styles.manage}
                    >
                      Manage Profile
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </div >
      </div >
    </div >
  );
}

export default Menu;
